import { parseISO } from 'date-fns';
import type { PasskeysDataObject } from './service';

export type Passkey = {
  _id: string;
  createdAt: Date;
  id: string;
  name: string;
  updatedAt: Date;
};

export const createPasskey = (data: PasskeysDataObject) => ({
  ...data,
  createdAt: parseISO(data.createdAt),
  updatedAt: parseISO(data.updatedAt),
});
